import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import {ErrorBoundary} from '@sentry/react';
import {StepHeader} from 'src/components/step-header';
import {useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {ErrorPage} from 'src/modules/error-page/error-page.components';
import {getActiveAccountProfileLicense} from 'src/openapi/admin/apis/AccountActiveLicenseApi';
import {useAppDispatch} from 'src/store/hooks';

import {StickyElement} from '@pb/kit-component-sticky-element';

import {BULK_IMPORT_USERS_STEPS, STEP_TITLE, TOOL_NAME} from './constants';
import {UploadFileControls, UserBulkImport, ValidateFileControls} from './user-bulk-import';
import {selectBulkUserImportStep} from './user-bulk-import/services/user-bulk-import.slice';

import {
    createUser,
    createUserHeader,
    createUserTitle,
} from './create-user.module.styl';

export const CreateUsers = () => {
    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : -1;
    const apiDispatch = useAppDispatch();

    const step = useSelector(selectBulkUserImportStep);
    const {canBulkImportUser} = useAdminAccessRight();
    const {bulkOpen} = useEventTracking();

    useEffect(() => {
        bulkOpen({toolName: TOOL_NAME});
        apiDispatch(getActiveAccountProfileLicense({accountId}));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!canBulkImportUser(accountId)) {
        return <ErrorPage subtitle="Contact your manager." title="Access denied"/>;
    }

    return (
        <ErrorBoundary>
            <div className={createUser}>
                <StickyElement className={createUserHeader}>
                    <div className={createUserTitle}>
                        <StepHeader title="Create Users" subTitle={STEP_TITLE[step]}/>
                        {step === BULK_IMPORT_USERS_STEPS.UPLOAD_FILE &&
                            <UploadFileControls/>}
                        {step === BULK_IMPORT_USERS_STEPS.VALIDATE_FILE &&
                            <ValidateFileControls/>}
                    </div>
                </StickyElement>
                <UserBulkImport/>
            </div>
        </ErrorBoundary>
    );
};
